import PropTypes from 'prop-types'
import { forwardRef, memo, useMemo } from 'react'
import useFallbackRef from 'lib/react/hooks/useFallbackRef'
import classNames from 'lib/util/classNames'
import styles from './Grid.module.scss'

/**
 * The `Grid`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
const Grid = forwardRef((props, forwardedRef) => {
  const { Tag, children, className, ...rest } = props
  const ref = useFallbackRef(forwardedRef)
  const classNameOutput = useMemo(
    () => classNames(className, styles.container),
    [className]
  )

  return (
    <Tag ref={ref} className={classNameOutput} {...rest}>
      {children}
    </Tag>
  )
})

// Display name
Grid.displayName = 'Grid'

/** @type {object} */
Grid.propTypes = {
  children: PropTypes.node,
  Tag: PropTypes.elementType,
  className: PropTypes.string
}

/** @type {object} */
Grid.defaultProps = {
  Tag: 'div',
  className: ''
}

// Memoize
export default memo(Grid)
